<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Raport</span>
        <h3 class="page-title">Raport SIO</h3>
      </d-col>
    </d-row>
    <d-card style="width: 100%;">
      <d-card-body>
          <d-row>
            <d-col md="4">
              <validation-observer
                      ref="download-form"
                      tag="form">
                <div class="form-group">
                  <label>
                    Wybierz rok
                  </label>
                  <validation-provider
                          rules="required"
                          name="duration"
                          v-slot="{ errors }">
                    <v-select
                            :options="dates"
                            style="width: 100%;"
                            class="form-control"
                            label="value"
                            v-model="date">
                    </v-select>
                  </validation-provider>
                </div>
              </validation-observer>
            </d-col>
            <d-col md="4">
              <validation-provider
                      name="institution_id"
                      v-slot="{ errors }">
                <label>Placówka:</label>
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                          placeholder="Wybierz placówkę"
                          :options="institutions"
                          v-model="data.institution_id"
                          :reduce="institution => institution.id"
                          :filterBy="filterByInstitution"
                          class="form-control"
                          label="id">
                    <template slot="no-options">
                      <template>Brak placówek o zadanych kryteriach</template>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }}
                      </div>
                    </template>
                  </v-select>
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </d-col>
            <d-col md="4">
              <validation-provider
                name="institution_id"
                v-slot="{ errors }">
                <label>Pracownik:</label>
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                    placeholder="Wybierz pracownika"
                    :options="users"
                    v-model="data.user_id"
                    :reduce="user => user.id"
                    :filterBy="filterByUsers"
                    class="form-control"
                    label="id">
                    <template slot="no-options">
                      <template v-if="!usersLoaded">Proszę czekać</template>
                      <template v-if="usersLoaded">Brak pracowników o zadanych kryteriach</template>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name }} {{ option.last_name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }} {{ option.last_name }}
                      </div>
                    </template>
                  </v-select>
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </d-col>
          </d-row>
          <d-row v-if="this.date.id === 0">
            <d-col md="8">
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  name="date_start"
                  v-slot="{ errors }">
                  <label>
                    Zakres dni dla raportu:
                  </label>
                  <date-picker
                    :class="['reservation-style', 'mr-2']"
                    v-model="data.date_range"
                    range
                    valueType="format"
                    style="width: 100%"/>
                </validation-provider>
              </div>
            </d-col>
          </d-row>
          <d-row>
            <d-col>
              <div class="align-middle">
                <d-button
                  style="width: 100px;"
                  theme="primary"
                  class="mr-2"
                  outline
                  :disabled="downloading !== false"
                  @click.prevent="downloadFile()">
                  <template v-if="!downloading"><i class="material-icons">cloud_download</i><span class="ml-2">Pobierz</span></template>
                  <template v-else>
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                  </template>
                </d-button>
              </div>
            </d-col>
          </d-row>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import api from '@/api';
import FormUtils from './../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'patients',
  components: { DatePicker },
  data() {
    return {
      loaded: false,
      downloading: false,
      institutions: [],
      users: [],
      date: {
        id: 0,
        value: '',
      },
      usersLoaded: false,
      data: {
        institution_id: null,
        user_id: null,
        date_range: null,
      },
      dates: []
    };
  },
  mounted () {
    this.getDates()
    this.getInstitutionsList();
    this.getUsersList();
  },
  methods: {
    getDates () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/reports/sio-years',
        outputKey: 'dates',
        loadedKey: 'loaded',
        noPagination: true,
        method: 'GET',
        successAction: () => {
          this.date = this.dates[this.dates.length - 1];
          this.dates.push({
            id: 0,
            value: 'Wybrany przedział dat'
          });
        }
      });
    },
    getInstitutionsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        outputKey: 'institutions',
        params: {
          pagination: false
        },
      });
    },
    getUsersList () {
      this.usersLoaded = false;
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'users',
        params: {
          pagination: false,
          where: {
            search: null,
            role: 'R_USER'
          }
        },
        successAction: () => {
          this.usersLoaded = true;
        }
      });
    },
    filterByInstitution (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    filterByUsers (option, label, search) {
      return (option.name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    downloadFile () {
      let filename = 'sio-report-' + this.date.value + '.xlsx';
      this.downloading = true;
      let valid = true;
      if (this.date.id === 0 && this.data.date_range === null) {
        this.downloading = false;
        Vue.swal({
          title: 'Wybierz przedział dat dla jakiego chcesz pobrać raport',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        valid = false;
      }
      if (valid === true) {
        axios({
          url: `${api}reports/sio-diagnosis-report`,
          params: {
            year: this.date.id,
            institution_id: this.data.institution_id,
            user_id: this.data.user_id,
            date_range: this.data.date_range
          },
          method: 'POST',
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.click();
          this.downloading = false;
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: 'Wystąpił błąd podczas pobierania',
            html: 'Spróbuj ponownie',
            type: 'warning',
            confirmButtonText: 'OK',
          });
          this.downloading = false;
        });
      }
    }
  }
};
</script>

